<template>
  <div class="mmp_bottom_nav">
    <ul class="inner">
      <li>
        <button
          type="button"
          class="btn_bottom_nav home active" @click="openHome"
        >
          <span class="txt">홈</span>
        </button>
      </li>
      <li>
        <button type="button" class="btn_bottom_nav search" @click="onClickTotalSearch">
          <span class="txt">검색</span>
        </button>
      </li>
      <li>
        <button type="button" class="btn_bottom_nav my" @click="openMyPage">
          <span class="txt">MY</span>
        </button>
      </li>
      <li>
        <button type="button" class="btn_bottom_nav map" @click="openMapMain">
          <span class="txt">오시는 길</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import commonMixin from '@/mixin/commonMixin'
import MmpUtils from '@/plugins/_common/MmpUtils'

export default {
  name: 'NrwBottom',
  mixins: [commonMixin, MmpUtils],
  data () {
    return {
      htmlClass: 'has_mmp_bottom_nav' // bottom navigation 존재를 선언하기 위해 <html> 태그에 추가할 클래스명
    }
  },
  computed: {
    paramCntnt02 () {
      const potltInfo = window.vue.getStore('courseList').state.portletList.find(item => item.potltCd === 'NRW_TXT_MENU')
      if (!potltInfo) return null
      const menuList = this.makeTreeForMenu(potltInfo.potltData)

      return menuList.menus[1].menus[0].paramCntnt02
    },
    isLogin () {
      return window.vue.getStore('root').state.session.authenticated
    }
  },
  created () {
  },
  mounted () {
    this.addHeaderClass()
  },
  beforeDestroy () {
    this.removeHeaderClass()
  },
  methods: {
    // 홈 이동
    openHome () {
      this.clickAction()
      this.$goPage({name: 'index'})
      // this.$router.push('/')
    },
    // 나의공간 이동
    async openMyPage () {
      this.clickAction()
      this.$goPage({ name: 'MyDashbrd' })
    },

    // 고객센터 이동
    openCustCntr () {
      this.clickAction()
      this.$goPage({ name: 'NoticeList', query: { paramCntnt02: this.paramCntnt02 } })
    },
    // 찾아오시는 길 이동
    openMapMain () {
      this.clickAction()
      this.$goPage({ name: 'MapMain' })
    },
    addHeaderClass () {
      const htmlTag = document.querySelector('html')
      if (htmlTag) {
        htmlTag.classList.add(this.htmlClass)
      }
    },
    removeHeaderClass () {
      const htmlTag = document.querySelector('html')
      if (htmlTag && htmlTag.classList.contains(this.htmlClass)) {
        htmlTag.classList.remove(this.htmlClass)
      }
    },
    // 메뉴 클릭 (터치 이펙트, 링크 이동)
    clickAction () {
      const parent = event.target.closest('li')
      const btn = parent.querySelector('.btn_bottom_nav')
      const btns = document.querySelectorAll('.mmp_bottom_nav .btn_bottom_nav')

      for (let i = 0; i < btns.length; i++) {
        btns[i].classList.remove('touched')
      }

      btn.classList.add('touched')
      setTimeout(function () {
        btn.classList.remove('touched')
      }, 800)
    },
    onClickTotalSearch () {
      this.$emit('onClickTotalSearch')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/layouts/NrwBottom.vue